// const portno = 'https://wellcareceramica-production-c058.up.railway.app';
const portno = 'http://192.168.35.9:6060';

function GetPortno(){
    return portno;
}

export default GetPortno
